import React from "react";
import { useEditSegment } from "./EditSegment.hooks";

const EditSegmentContext = React.createContext<ReturnType<
  typeof useEditSegment
> | null>(null);

export function useEditSegmentView() {
  const contextValue = React.useContext(EditSegmentContext);
  if (!contextValue) {
    throw Error("Should be used inside the EditSegmentProvider");
  }
  return contextValue;
}

export const EditSegmentProvider = EditSegmentContext.Provider;
